/* =========================================================================
   ClueVine — monetization config
   "Beer money, low effort" Supporter unlock. No backend, no accounts.

   How it works:
   1. In Stripe, create a Payment Link (https://dashboard.stripe.com/payment-links)
      for a small one-time "Supporter" product (e.g. $3).
   2. In that Payment Link's settings, set "After payment → Don't show confirmation
      page → Redirect to" your site WITH the supporter flag, e.g.
      https://cluevine.com/?supporter=ok
   3. Paste the Payment Link URL into SUPPORT_URL below.

   When a buyer returns to /?supporter=ok, ClueVine flips a local "supporter" flag
   (it unlocks the bonus theme skins). This is an honor system — anyone can visit
   that URL — which is the right trade-off for $3 cosmetics with no backend.
   ========================================================================= */

/** Your Stripe Payment Link. Leave empty to hide the Support button entirely. */
export const SUPPORT_URL = '';

/** Query flag your Stripe redirect appends; visiting /?<flag>=… unlocks supporter. */
export const SUPPORTER_REDIRECT_FLAG = 'supporter';

/**
 * Voluntary tip jar — a Ko-fi or Buy Me a Coffee link (e.g. https://ko-fi.com/you
 * or https://buymeacoffee.com/you). Pure goodwill, no unlock. Empty hides it.
 */
export const TIP_URL = '';

/**
 * Google AdSense. Set both to show a single banner to non-supporters (supporters
 * get it removed). ADSENSE_CLIENT is your publisher id ("ca-pub-…"); ADSENSE_SLOT
 * is the ad-unit id from your AdSense dashboard. Leave empty for no ads.
 * Note: AdSense only serves on an approved domain, never on localhost.
 */
export const ADSENSE_CLIENT = '';
export const ADSENSE_SLOT = '';

/**
 * Show the ad to every non-supporter visitor (needs ADSENSE_CLIENT + ADSENSE_SLOT).
 * This is the site-wide switch; the in-app admin toggle only previews on the
 * owner's own device.
 */
export const ADS_ENABLED = false;

/**
 * Soft gate for the in-app admin area. This is client-side obscurity, NOT
 * security — anyone can read the bundle. Real auth belongs on your server (e.g.
 * gate /admin behind a login once you wire up MySQL). Change this before launch.
 */
export const ADMIN_PASSPHRASE = 'let-me-in';

/**
 * Canonical site URL appended to shared results, so a shared score links back
 * and unfurls with og.png. Leave empty to use the current origin at runtime —
 * already correct on any deploy, including cluevine.com. Set it only to force a
 * canonical domain (e.g. when the live site is also reachable at a preview URL).
 */
export const SITE_URL = '';
